module.exports = __webpack_public_path__ + "img/cancel_confimed_bet.3dcfd9a3.png";